import * as types from './loadingActionTypes';

const initialState = {
  isLoading: null,
  fullLoading: {
    isLoading: false,
    loadingText: '',
  },
  error: {
    type: null,
    data: null,
  },
};

export const loadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LOADING:
      const loading = state.isLoading ? state.isLoading : {};
      loading[action.payload.key] = action.payload.isLoading;

      return {
        ...state,
        isLoading: loading ? Object.assign({}, loading) : null,
      };
    case types.LOADING_FULL:
      return {
        ...state,
        fullLoading: {
          isLoading: action?.payload?.isLoading ? action?.payload.isLoading : false,
          loadingText: action?.payload?.loadingText ? action?.payload?.loadingText : '',
        },
      };
    default:
      return state;
  }
};
